// extracted by mini-css-extract-plugin
module.exports = {"cover":"_2bfaXuu","top-gradient":"_2KdfFje","topGradient":"_2KdfFje","title-box":"_3s-i-l8","titleBox":"_3s-i-l8"};